import { render, staticRenderFns } from "./PlanetCard.vue?vue&type=template&id=3a0f8e18&scoped=true&"
import script from "./PlanetCard.vue?vue&type=script&lang=js&"
export * from "./PlanetCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanetCard.vue?vue&type=style&index=0&id=3a0f8e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f8e18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
